import React from 'react';

import * as S from './TabWrap.styles';
import { SectionType } from './types';

type TabWrapProps = {
  sections: SectionType[];
};
export function TabWrap(props: TabWrapProps): React.ReactElement {
  const { sections } = { ...props };

  const sectionsMapped = sections?.map((section: SectionType) => (
    <React.Fragment key={section.id}>{section.content}</React.Fragment>
  ));

  return <S.Container>{sectionsMapped}</S.Container>;
}
